var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconzocialEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 12.825,
    viewBox: "0 0 19 12.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-email",
    "data-name": "Icon zocial-email",
    d: "M.072,15.757V5.2q0-.018.055-.348l6.211,5.313L.145,16.124a1.553,1.553,0,0,1-.073-.366ZM.9,4.123a.79.79,0,0,1,.311-.055H17.936a1.037,1.037,0,0,1,.33.055l-6.23,5.332-.824.66L9.581,11.452,7.95,10.114l-.824-.66ZM.915,16.838l6.248-5.991,2.419,1.96L12,10.847l6.248,5.991a.88.88,0,0,1-.311.055H1.208a.83.83,0,0,1-.293-.055Zm11.909-6.669,6.193-5.313a1.094,1.094,0,0,1,.055.348V15.757a1.4,1.4,0,0,1-.055.366Z",
    transform: "translate(-0.072 -4.068)",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconzocialEmail);
export default __webpack_public_path__ + "static/media/Icon zocial-email.d02dfdcb908218c9407f5a5051b8d8ac.svg";
export { ForwardRef as ReactComponent };